import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

// Shape picture from object storage (authorised fetch, cached per session).
export function ShapeThumb({ shape, src, className = "h-12 w-12", testId }) {
  const [url, setUrl] = useState(src || null);
  const key = shape?.has_image ? `${shape.id}:${shape.updated_at || ""}` : null;
  useEffect(() => {
    if (src || !key) return;
    if (!cache.has(key)) {
      cache.set(key, api.get(`/shapes/${shape.id}/image`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data)).catch(() => { cache.delete(key); return null; }));
    }
    let alive = true;
    cache.get(key).then((u) => alive && setUrl(u));
    return () => { alive = false; };
  }, [key, src, shape?.id]);
  return (
    <div data-testid={testId} className={`grid shrink-0 place-items-center overflow-hidden rounded-md border border-slate-800 bg-white ${className}`}>
      {url ? <img src={url} alt={shape?.name || "Shape"} className="h-full w-full object-contain" /> : <span className="text-[9px] text-slate-500">No picture</span>}
    </div>
  );
}
